// extracted by mini-css-extract-plugin
module.exports = {"activityBlock":"ActivityBlock_activityBlock__6Hwpf","activityBlockSmall":"ActivityBlock_activityBlockSmall__7Hran"};